export const ON_TOGGLE_ROW = `multiSelects@ON_TOGGLE_ROW`
export const ON_MULTISELECT_TOGGLE = 'multiSelects@ON_MULTISELECT_TOGGLE'
export const ON_SELECTION_CLEAR = 'multiSelects@ON_SELECTION_CLEAR'
